import Logo from '@assets/images/reserveat-logo-text-small.png'

export const CCLogo = ({ style = { height: '50px' } }: any) => {
    return (
        <img src={Logo} alt='Reserve Logo with Typography' style={style} />
    )
}
